// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-67ded870]{width:.8rem;height:.8rem}.add[data-v-67ded870]{width:1.73333rem;height:1.73333rem;margin-bottom:.53333rem}", ""]);
// Exports
module.exports = exports;
